/**
 * @deprecated This hook is deprecated. The entitlements system now handles
 * insufficient resources via 402 errors and EntitlementContext.
 * Keeping this stub to avoid breaking existing imports.
 */
export const useCheckCredits = () => {
  // No-op checkCredits - entitlements are now handled by EntitlementContext
  const checkCredits = (fn) => {
    // Always execute the function - entitlements are validated server-side
    // and 402 errors trigger InsufficientEntitlementsModal via EntitlementContext
    return Promise.resolve(fn?.());
  };

  // Empty dialog component - no longer needed
  const NoCreditDialog = () => null;

  return {
    checkCredits,
    NoCreditDialog,
    open: false,
  };
};
